// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NumberInput-base__mcIlP input[type=number]::-webkit-inner-spin-button,.NumberInput-base__mcIlP input[type=number]::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.NumberInput-base__mcIlP input[type=number]{-moz-appearance:textfield}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NumberInput-base__mcIlP"
};
export default ___CSS_LOADER_EXPORT___;
